"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteBookingSidebarPills = void 0;
var React = require("react");
var generic_1 = require("../../generic");
var buttons_1 = require("../../buttons");
var SiteBookings_1 = require("./SiteBookings");
var SiteBookingSidebarPills = function (_a) {
    var sidebar = _a.sidebar, setSidebar = _a.setSidebar, can_message = _a.can_message, newMessage = _a.newMessage, newBooking = _a.newBooking;
    var bookings_pill = (React.createElement("li", { className: "nav-item" },
        React.createElement("a", { className: "nav-link " +
                (sidebar == SiteBookings_1.SideBar.BOOKINGS ? "active" : ""), onClick: function () { return setSidebar(SiteBookings_1.SideBar.BOOKINGS); } },
            React.createElement(generic_1.Icon, { name: "calendar-day", size: "1x" }),
            " ",
            gettext("Bookings"))));
    var messages_pill = (React.createElement("li", { className: "nav-item" },
        React.createElement("a", { className: "nav-link " +
                (sidebar == SiteBookings_1.SideBar.MESSAGES ? "active" : ""), onClick: function () { return setSidebar(SiteBookings_1.SideBar.MESSAGES); } },
            React.createElement(generic_1.Icon, { name: "comments", size: "1x" }),
            " ",
            gettext("Messages"))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "col-8" },
            React.createElement("div", { className: "nav nav-pills" },
                bookings_pill,
                messages_pill)),
        React.createElement("div", { className: "col-4 text-right" }, sidebar == SiteBookings_1.SideBar.BOOKINGS ? (React.createElement(buttons_1.PrimaryButton, { onClick: newBooking }, gettext("New Booking"))) : (can_message && (React.createElement(buttons_1.PrimaryButton, { onClick: newMessage }, gettext("New Message")))))));
};
exports.SiteBookingSidebarPills = SiteBookingSidebarPills;
